import auth from "@/middleware/auth";

export default [
    {
        path: "propostasCdc",
        name: "propostasCdc",
        meta: { middleware: [auth] },
        component: () => import("./PropostasCdc")
    }
];
